
import React from 'react';

export const BannerSection: React.FC = () => {
  return (
    <section className="relative h-96 bg-gradient-to-r from-emerald-600 to-teal-700 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/banners/hero-group-tours.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 h-full flex items-center">
        <div className="w-full max-w-2xl">
          <h1 className="text-5xl font-bold text-white mb-6">
            Explore the World
          </h1>
          <p className="text-xl text-white/90 leading-relaxed">
            Embark on a luxurious journey with PrimeMeridian and discover breathtaking destinations around the globe. From exotic islands to vibrant cities, our expertly crafted itineraries promise an unforgettable experience filled with adventure and relaxation.
          </p>
        </div>
      </div>
    </section>
  );
};
